import { render } from "./OidoCardSubtitle.vue?vue&type=template&id=dc36993a"
import script from "./OidoCardSubtitle.vue?vue&type=script&lang=js"
export * from "./OidoCardSubtitle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__